import React from 'react';
import { $Drawer, $IconButton, $DrawerContent, $DrawerContainer } from './styles';
import { SvgIcon } from '../SvgIcon';
export const Drawer = ({ children, maxWidth, left, variant = 'permanent', open = false, noHorizPadding = false, noTopPadding, onChange }) => {
    return React.createElement($Drawer, { maxWidth: maxWidth, variant: variant, anchor: left ? 'left' : 'right', open: open },
        React.createElement($DrawerContainer, null,
            React.createElement($IconButton, { left: left, open: open, onClick: onChange }, open ? React.createElement(SvgIcon, { name: left ? 'chevron-left' : 'chevron-right' }) : React.createElement(SvgIcon, { name: left ? 'chevron-right' : 'chevron-left' })),
            React.createElement($DrawerContent, { open: open, noHorizPadding: noHorizPadding, noTopPadding: noTopPadding }, children)));
};
